import React from 'react'
import Button, { ButtonProps } from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'

interface LoadingButtonProps extends ButtonProps {
  isLoading?: boolean
}

const LoadingButton: React.FC<LoadingButtonProps> = ({
  isLoading = false,
  children,
  disabled,
  color = "primary",
  size = "medium",
  ...rest
}) => {
  const spinnerSize =
    size === "small" ? 16 :
    size === "large" ? 20 :
    18;
  return (
    <Button
      {...rest}
      color={color}
      disabled={disabled || isLoading}
      startIcon={
        isLoading ? (
          <CircularProgress
            size={spinnerSize}
            sx={{ color: "currentColor" }}
          />
        ) : (
          rest.startIcon
        )
      }
    >
      {children}
    </Button>
  )
}

export default LoadingButton
